var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasicPromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4864 1.08361C22.9843 0.581505 22.1702 0.581505 21.668 1.08361L16.252 6.49966C15.7499 7.00178 15.7499 7.81584 16.252 8.31794C16.7541 8.82005 17.5682 8.82005 18.0703 8.31794L23.4864 2.90188C23.9885 2.39978 23.9885 1.58571 23.4864 1.08361Z",
    fill: "#5D89EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4386 2.61731C12.6441 2.53938 12.8644 2.50835 13.0834 2.52654C13.1033 2.52819 13.123 2.53052 13.1427 2.53353L19.7007 3.54114C20.0405 3.57661 20.3583 3.72776 20.6006 3.96992C20.8426 4.21208 20.9938 4.52989 21.0293 4.86973L22.0368 11.4277C22.0399 11.4474 22.0423 11.4672 22.0438 11.487C22.062 11.706 22.031 11.9263 21.9531 12.1318C21.8765 12.3336 21.7567 12.5161 21.6019 12.6665L10.4472 23.8212C10.0454 24.2225 9.50039 24.4482 8.93252 24.4482C8.36466 24.4482 7.82003 24.2228 7.41824 23.8215L0.749289 17.1526C-0.0664883 16.3357 -0.0668644 14.9404 0.748914 14.1236L11.9039 2.96859C12.0542 2.8138 12.2368 2.69387 12.4386 2.61731Z",
    fill: "#B3D5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2737 9.65272C15.4557 9.65272 14.7925 8.98959 14.7925 8.17157C14.7925 7.35356 15.4557 6.69043 16.2737 6.69043C17.0917 6.69043 17.7548 7.35356 17.7548 8.17157C17.7548 8.98959 17.0917 9.65272 16.2737 9.65272Z",
    fill: "#5D89EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPromotion);
export default __webpack_public_path__ + "static/media/basic-promotion.d2da4dc5.svg";
export { ForwardRef as ReactComponent };